var _a;
import logger from '../../../core/utils/src/logger';
export var HEADER = 'header';
export var DIVIDER = 'divider';
export var LINK = 'link';
export var SECTION = 'section';
export var LINK_GROUP = 'link-group';
export var EXPANDABLE_LINK_GROUP = 'expandable-link-group';
var dataFormat = (_a = {},
    _a[HEADER] = ['text', 'href'],
    _a[LINK] = ['type', 'text', 'href'],
    _a[SECTION] = ['type', 'text', 'items'],
    _a[LINK_GROUP] = ['type', 'text', 'items', 'href'],
    _a[EXPANDABLE_LINK_GROUP] = ['type', 'text', 'items', 'href'],
    _a[DIVIDER] = ['type'],
    _a);
export var hasActiveLink = function (item, activeHref) {
    if (item.href && item.href === activeHref) {
        return true;
    }
    if (item.items) {
        return item.items.some(function (i) { return hasActiveLink(i, activeHref); });
    }
    return false;
};
var validateHrefDuplicates = function (items, scannedHrefs) {
    if (items === void 0) { items = []; }
    if (scannedHrefs === void 0) { scannedHrefs = {}; }
    items.forEach(function (item) {
        if (item.href) {
            if (scannedHrefs[item.href]) {
                logger.warn("Items contain a duplicated href: \"" + item.href + "\".");
            }
            else {
                scannedHrefs[item.href] = true;
            }
        }
        validateHrefDuplicates(item.items, scannedHrefs);
    });
};
export var validateDataFormat = function (item, typeName) {
    var requiredProperties = dataFormat[typeName];
    var isMissing = function (prop) { return item[prop] === undefined; };
    var missing = requiredProperties.filter(isMissing);
    if (missing.length) {
        logger.error("Missing properties [" + missing.join(', ') + "] in \"" + typeName + "\" item.");
    }
};
export var validateItems = function (items) {
    if (items === void 0) { items = []; }
    validateHrefDuplicates(items);
    items.forEach(function (item) {
        if (!item.type) {
            logger.error('Item type is not specified.');
        }
        if (!dataFormat.hasOwnProperty(item.type)) {
            logger.error("Unknown item type: \"" + item.type + "\".");
        }
        validateDataFormat(item, item.type);
        validateItems(item.items);
    });
};
export var generateExpandableItemsIndex = function (items, index, expandableParents) {
    if (index === void 0) { index = []; }
    if (expandableParents === void 0) { expandableParents = []; }
    items.forEach(function (item) {
        var nextLevelParents = expandableParents.slice();
        if (item.type === SECTION || item.type === EXPANDABLE_LINK_GROUP) {
            index.push({ item: item, expanded: item.expanded, expandableParents: expandableParents });
            nextLevelParents.unshift(item);
        }
        if (item.items) {
            generateExpandableItemsIndex(item.items, index, nextLevelParents);
        }
    });
    return index;
};
//# sourceMappingURL=utils.js.map